<main class="privacy-policy-component">
  <div class="wrapper scroll" id="mainAppScroll">
    <div class="content">
      <span
        class="fixed-space-32"
        aria-hidden="true"
        *ngIf="(lessThan$ | async)?.mobileL !== true"></span>
      <article class="content-wrapper">
        <ng-container *ngIf="lang === 'PT'">
          <h1 id="pol%C3%ADticadeprivacidade">Política de Privacidade</h1>

          <h5 id="%C3%9Altimaatualiza%C3%A7%C3%A3o%3A14dejulhode2020">
            Última atualização: 14 de julho de 2020
          </h5>

          <p>
            A presente Política de Privacidade tem por finalidade demonstrar o compromisso
            da empresa Popsy atividades de internet LTDA, pessoa jurídica de direito
            privado, com sede na cidade de São Paulo, estado de São Paulo, na Av.
            Paulista, 1374, 11 andar, Bela Vista, São Paulo, SP 01310&#8211;100, inscrita
            no CNPJ/MF sob n º 36.930.174/0001&#8211;090, com a privacidade e a proteção
            dos dados pessoais de seus usuários, estabelecendo as regras sobre a coleta,
            registro, armazenamento, uso, compartilhamento, enriquecimento e eliminação
            dos dados coletados dentro do escopo dos serviços e funcionalidades
            oferecidos, de acordo com as leis em vigor.
          </p>

          <p>
            Como condição para acesso e uso das funcionalidades exclusivas do Popsy, o
            usuário declara ser maior de 13 (treze) anos e ter lido por completo e
            atentamente as regras deste documento e dos Termos de Uso, estando plenamente
            ciente conferindo assim sua livre e expressa concordância com os termos aqui
            estipulados. Caso não esteja de acordo com estas diretrizes, deverá
            descontinuar o seu acesso.
          </p>

          <h2 id="informa%C3%A7%C3%B5esquen%C3%B3scoletamoserecebemossobrevoc%C3%AA">
            Informações que nós coletamos e recebemos sobre você
          </h2>

          <p>
            Sua privacidade é muito importante para nós. Desse modo, desenvolvemos esta
            Política de Privacidade para você compreender como nós coletamos, usamos,
            comunicamos, divulgamos e fazemos uso de suas informações pessoais.
          </p>

          <p>
            Antes, ou no momento em que estivermos coletando suas informações pessoais,
            nós identificaremos a finalidade para quais esses dados estão sendo coletados.
            Nós recolheremos e usaremos as informações pessoais exclusivamente com o
            objetivo de completar as finalidades especificadas por nós e para propósitos
            similares, a menos que obtenhamos o consentimento do indivíduo em questão ou
            conforme exigido por lei.<br />
            Apenas manteremos as informações pessoais enquanto for necessário para o<br />
            cumprimento desses propósitos.
          </p>

          <p>
            Coletaremos as informações pessoais por meios legais e justos e, quando
            apropriado, com o conhecimento ou consentimento do indivíduo em questão.<br />
            Os dados pessoais devem ser relevantes para os propósitos aos quais serão
            utilizados e, na medida necessária para sua finalidade, devem ser precisos,
            completos e atualizados.<br />
            Protegeremos suas informações pessoais com medidas razoáveis de segurança
            contra perda ou roubo, bem como acesso não autorizado, divulgação, cópia, uso
            ou modificação.
          </p>

          <p>
            Disponibilizaremos prontamente aos usuários informações sobre nossas políticas
            e práticas relacionadas ao gerenciamento de informações pessoais. Estamos
            comprometidos a conduzir nosso negócio de acordo com esses princípios, a fim
            de garantir que a confidencialidade das informações pessoais seja protegida e
            mantida.
          </p>

          <h2 id="comousamosasinforma%C3%A7%C3%B5escoletadas">
            Como usamos as informações coletadas
          </h2>

          <p>
            Podemos utilizar maneiras para coletar informações pessoais dos usuários
            relacionadas aos serviços, atividades, características ou recursos disponíveis
            em nossos aplicativos móveis.
          </p>

          <p>
            Os usuários podem acessar nosso aplicativo móvel no modo anônimo. Apenas
            coletaremos os dados de identificação pessoal dos usuários que voluntariamente
            os enviarem para nós. Os usuários sempre podem se recusar a fornecer seus
            dados de identificação pessoal, exceto que isso pode impedir o envolvimento em
            certas atividades relacionadas ao site.
          </p>

          <p>
            Podemos coletar dados não pessoais de identificação sobre os usuários sempre
            que eles interagirem com nossos aplicativos móveis. Dados não pessoais de
            identificação podem incluir o nome do navegador e o modelo do computador. Os
            dados técnicas sobre os usuários podem indicar a forma de conexão com nosso
            site, como o sistema operacional, os provedores de serviços de internet
            utilizados e outras informações semelhantes.
          </p>

          <p>
            Popsy e Popsy atividades de internet LTDA podem coletar e usar informações
            pessoais para os seguintes propósitos: personalizar a experiência do usuário -
            podemos usar dados para compreender de que forma os usuários, como um grupo,
            usam os serviços e recursos oferecidos em nossos aplicativos móveis.
          </p>

          <p>
            Mediante solicitação do usuário, os dados poderão ser apagados antes desse
            prazo. No entanto, pode ocorrer de os dados precisarem ser mantidos por
            período superior, por motivo de lei, ordem judicial, prevenção à fraude (art.
            11, II, “a” da Lei Geral de Proteção de Dados “LGPD”, Lei nº 13.709/2018),
            proteção ao crédito (art. 7º, X, LGPD) e outros interesses legítimos, em
            conformidade com o artigo 10 da LGPD. Findo o prazo e a necessidade legal,
            serão deletados por meio de métodos de exclusão seguros ou utilizados de forma
            anônima para fins estatísticos.
          </p>

          <h2 id="compartilhamentosdassuasinforma%C3%A7%C3%B5espessoais">
            Compartilhamentos das suas informações pessoais
          </h2>

          <p>
            Nós não vendemos, negociamos ou alugamos informações de identificação pessoal
            para terceiros. Podemos compartilhar informações demográficas genéricas não
            vinculadas a nenhuma informação de identificação pessoal referente aos nossos
            visitantes e usuários com nossos parceiros de negócios, afiliados e
            anunciantes confiáveis ​​para os propósitos descritos acima.
          </p>

          <h2 id="altera%C3%A7%C3%B5esnapol%C3%ADticadeprivacidade">
            Alterações na Política de Privacidade
          </h2>

          <p>
            Popsy e Popsy atividades de internet LTDA têm o poder de atualizar esta
            política de privacidade a qualquer momento. Quando o fizermos, revisaremos e
            atualizaremos a data no topo desta página. Encorajamos os usuários a checarem
            esta página frequentemente para ficarem por dentro de possíveis alterações e
            sobre como estamos ajudando a proteger as informações pessoais que coletamos.
          </p>

          <p>
            Você reconhece e concorda que é sua responsabilidade verificar esta Política
            de Privacidade periodicamente e tomar conhecimento das alterações.
          </p>

          <h2 id="suaaceita%C3%A7%C3%A3odestestermos">Sua aceitação destes termos</h2>

          <p>
            Ao usar nossos serviços você implica sua aceitação aos termos e condições
            desta Política de Privacidade. Se você não aceitar, por favor não utilize
            nossos serviços. O uso continuado dos mesmos após a publicação de alterações
            desta política será considerado como aceitação das mesmas.
          </p>

          <h2 id="comoentraremcontatoconosco">Como entrar em contato conosco</h2>

          <p>
            Se você tiver dúvidas ou alguma preocupação referente às nossas práticas de
            privacidade, ou caso deseje fazer uma solicitação sobre suas informações, por
            favor entre em contato conosco pelo email:
            <a href="mailto:contact@popsy.app">contact&#64;popsy.app</a>
          </p>

          <h2 id="delete-my-account">Apagando minha conta</h2>

          <p>
            Estamos muito tristes em vê-lo partir, e gostaríamos de saber o que poderíamos
            fazer para melhorar sua experiência em Popsy, por favor, envie-nos um e-mail
            para
            <a href="mailto:contact@popsy.app?subject=Delete%20my%20account"
              >contact&#64;popsy.app</a
            >
            com seus comentários, e os leremos e usaremos para melhorar nosso aplicativo.
          </p>
          <p>
            Se você for claro sobre isso e quiser apagar sua conta, basta seguir estes
            passos.
          </p>

          <h3 id="delete-my-account-android">Android</h3>

          <ul>
            <li>Abrir Popsy</li>
            <li>Deslize o painel direito a partir da tela inicial</li>
            <li>
              Pressione o botão com os três pontos para ver mais opções na parte superior
              direita.
            </li>
            <li>Toque em 'Abrir preferências'.</li>
            <li>Pressione o botão com os três pontos na parte superior direita.</li>
            <li>Toque em 'Apagar minha conta'.</li>
            <li>A imprensa continua no diálogo de confirmação</li>
          </ul>

          <h3 id="delete-my-account-web">Web</h3>

          <ul>
            <li>Vá para https://www.popsy.app/ e faça o login com sua conta.</li>
            <li>Vá para https://www.popsy.app/es/settings/user</li>
            <li>Confirme que você deseja excluir sua conta.</li>
          </ul>

          <h3 id="delete-my-account-ios">iOS</h3>

          <ul>
            <li>Abrir Popsy</li>
            <li>Faça o login com sua conta</li>
            <li>Ir para a tela de ajustes</li>
            <li>Toque em 'apagar conta'.</li>
          </ul>
        </ng-container>
        <ng-container *ngIf="lang === 'FR'">
          <h1 id="politiquedeconfidentialit%C3%A9">Politique de confidentialité</h1>

          <h5 id="derni%C3%A8remise%C3%A0jour%3A19juillet2020">
            Dernière mise à jour : 19 juillet 2020
          </h5>

          <p>
            La présente politique de confidentialité décrit les pratiques de Popsy,
            représenté par Popsy, LLC, concernant les informations et données personnelles
            identifiables (&#8220;informations personnelles&#8221;). Cette politique
            s&#8217;applique à nos sites web, applications mobiles, courriels et messages
            textuels, et comptes de médias sociaux (les &#8220;Plateformes&#8221;).
            Lorsque vous utilisez les Plateformes, vous acceptez les termes de cette
            politique.
          </p>

          <h2 id="informationsquenousrecueillonsetrecevons%C3%A0votresujet">
            Informations que nous recueillons et recevons à votre sujet
          </h2>

          <p>
            Votre vie privée est très importante pour nous. En conséquence, nous avons
            élaboré la présente politique afin que vous compreniez comment nous
            recueillons, utilisons, communiquons et divulguons les informations
            personnelles et comment nous les utilisons.
          </p>

          <p>
            Avant ou au moment de la collecte d&#8217;informations personnelles, nous
            identifierons les fins pour lesquelles les informations sont collectées.
          </p>

          <p>
            Nous collecterons et utiliserons les informations personnelles uniquement dans
            le but d&#8217;atteindre les objectifs que nous aurons spécifiés et pour
            d&#8217;autres objectifs compatibles, sauf si nous obtenons le consentement de
            la personne concernée ou si la loi l&#8217;exige.
          </p>

          <p>
            Nous ne conserverons les informations personnelles qu&#8217;aussi longtemps
            que nécessaire pour la réalisation de ces objectifs.
          </p>

          <p>
            Nous recueillerons les informations personnelles par des moyens légaux et
            équitables et, le cas échéant, au su ou avec le consentement de la personne
            concernée.
          </p>

          <p>
            Les données personnelles doivent être pertinentes par rapport aux objectifs
            pour lesquels elles sont utilisées et, dans la mesure nécessaire à ces
            objectifs, elles doivent être exactes, complètes et à jour.
          </p>

          <p>
            Nous protégerons les informations personnelles par des mesures de sécurité
            raisonnables contre la perte ou le vol, ainsi que contre l&#8217;accès, la
            divulgation, la copie, l&#8217;utilisation ou la modification non autorisés.
          </p>

          <p>
            Nous mettrons à la disposition de nos clients des informations sur nos
            politiques et pratiques en matière de gestion des informations personnelles.
          </p>

          <p>
            Nous nous engageons à mener nos activités conformément à ces principes afin de
            garantir que la confidentialité des informations personnelles est protégée et
            maintenue.
          </p>

          <h2 id="commentnousutilisonslesinformationscollect%C3%A9es">
            Comment nous utilisons les informations collectées
          </h2>

          <p>
            Nous pouvons recueillir des informations d&#8217;identification personnelle
            des Utilisateurs de différentes manières en rapport avec les activités, les
            services, les caractéristiques ou les ressources que nous mettons à
            disposition sur nos Applications Mobiles.
          </p>

          <p>
            Les utilisateurs peuvent visiter notre application mobile de manière anonyme.
            Nous ne recueillons des informations d&#8217;identification personnelle des
            utilisateurs que s&#8217;ils nous les communiquent volontairement. Les
            utilisateurs peuvent toujours refuser de fournir des informations
            d&#8217;identification personnelle, sauf que cela peut les empêcher de
            s&#8217;engager dans certaines activités liées au site.
          </p>

          <p>
            Nous pouvons collecter des informations d&#8217;identification non
            personnelles sur les Utilisateurs lorsqu&#8217;ils interagissent avec nos
            Applications Mobiles. Les informations d&#8217;identification non personnelles
            peuvent inclure le nom du navigateur, le type d&#8217;ordinateur et des
            informations techniques sur les moyens de connexion des utilisateurs à notre
            site, tels que le système d&#8217;exploitation et les fournisseurs de services
            Internet utilisés, ainsi que d&#8217;autres informations similaires.
          </p>

          <p>
            Popsy et Popsy, LLC peuvent recueillir et utiliser les informations
            personnelles des utilisateurs aux fins suivantes : Pour personnaliser
            l&#8217;expérience de l&#8217;utilisateur - Nous pouvons utiliser les
            informations dans leur ensemble pour comprendre comment nos utilisateurs en
            tant que groupe utilisent les services et les ressources fournis sur nos
            applications mobiles.
          </p>

          <h2 id="partagedevosinformationspersonnelles">
            Partage de vos informations personnelles
          </h2>

          <p>
            Nous ne vendons, n&#8217;échangeons ni ne louons à des tiers les informations
            d&#8217;identification personnelle des utilisateurs. Nous pouvons partager des
            informations démographiques agrégées génériques non liées à des informations
            d&#8217;identification personnelle concernant les visiteurs et les
            utilisateurs avec nos partenaires commerciaux, nos affiliés de confiance et
            nos annonceurs aux fins décrites ci-dessus.
          </p>

          <h2 id="modificationsdecettepolitiquedeconfidentialit%C3%A9">
            Modifications de cette politique de confidentialité
          </h2>

          <p>
            Popsy et Popsy, LLC ont le pouvoir discrétionnaire de mettre à jour cette
            politique de confidentialité à tout moment. Lorsque nous le ferons, nous
            réviserons la date de mise à jour indiquée en haut de cette page. Nous
            encourageons les utilisateurs à consulter fréquemment cette page pour prendre
            connaissance des changements éventuels afin de rester informés de la manière
            dont nous contribuons à la protection des informations personnelles que nous
            recueillons. Vous reconnaissez et acceptez qu&#8217;il est de votre
            responsabilité de revoir périodiquement cette politique de confidentialité et
            de prendre connaissance des modifications.
          </p>

          <h2 id="votreacceptationdecesconditions">
            Votre acceptation de ces conditions
          </h2>

          <p>
            En utilisant nos services, vous signifiez votre acceptation de cette politique
            et de ces conditions générales. Si vous n&#8217;êtes pas d&#8217;accord,
            veuillez ne pas utiliser nos services. Si vous continuez à utiliser nos
            services après la publication de modifications à la présente politique, vous
            serez réputé avoir accepté ces modifications.
          </p>

          <h2 id="pournouscontacter">Pour nous contacter</h2>

          <p>
            Si vous avez des questions ou des préoccupations concernant nos pratiques en
            matière de protection de la vie privée ou si vous souhaitez faire une demande
            concernant vos informations, veuillez nous contacter à l&#8217;adresse
            suivante : <a href="mailto:contact@popsy.app">contact&#64;popsy.app</a>
          </p>

          <h2 id="delete-my-account">Suppression de mon compte</h2>

          <p>
            Nous sommes très tristes de vous voir partir, et nous aimerions savoir ce que
            nous pourrions faire pour améliorer votre expérience sur Popsy. N'hésitez pas
            à nous envoyer un e-mail à
            <a href="mailto:contact@popsy.app?subject=Delete%20my%20account"
              >contact&#64;popsy.app</a
            >
            avec vos commentaires, et nous les lirons et les utiliserons pour améliorer
            notre application.
          </p>
          <p>
            Si vous êtes clair et que vous voulez supprimer votre compte, suivez
            simplement les étapes suivantes.
          </p>

          <h3 id="delete-my-account-android">Android</h3>

          <ul>
            <li>Ouvrez Popsy</li>
            <li>Faites glisser le panneau de droite depuis l'écran d'accueil</li>
            <li>
              Appuyez sur le bouton avec les trois points pour voir plus d'options dans la
              partie supérieure droite.
            </li>
            <li>Appuyez sur "Ouvrir les préférences".</li>
            <li>
              Appuyez sur le bouton avec les trois points dans la partie supérieure
              droite.
            </li>
            <li>Tapez sur "Supprimer mon compte".</li>
            <li>Appuyez sur continuer dans la boîte de dialogue de confirmation</li>
          </ul>

          <h3 id="delete-my-account-web">Web</h3>

          <ul>
            <li>Allez sur https://www.popsy.app/ et connectez-vous avec votre compte.</li>
            <li>Allez sur https://www.popsy.app/es/settings/user</li>
            <li>Confirmez que vous voulez supprimer votre compte.</li>
          </ul>

          <h3 id="delete-my-account-ios">iOS</h3>

          <ul>
            <li>Ouvrez Popsy</li>
            <li>Connectez-vous avec votre compte</li>
            <li>Accédez à l'écran des paramètres</li>
            <li>Tapez sur "supprimer le compte".</li>
          </ul>
        </ng-container>
        <ng-container *ngIf="lang === 'ES'">
          <h1 id="pol%C3%ADticadeprivacidad">Política de privacidad</h1>

          <h5 id="%C3%9Altimaactualizaci%C3%B3n%3A10deenerode2019">
            Última actualización: 10 de enero de 2019
          </h5>

          <p>
            Esta Política de Privacidad describe las prácticas de Popsy, representada por
            Popsy, LLC, con respecto a la información y los datos de identificación
            personal (&#8220;información personal&#8221;). Esta política se aplica a
            nuestros sitios web, aplicaciones móviles, correo electrónico y mensajes de
            texto, y cuentas de medios sociales (las &#8220;Plataformas&#8221;). Al
            utilizar las Plataformas, usted acepta los términos de esta política.
          </p>

          <h2 id="informaci%C3%B3nquerecopilamosyrecibimossobreusted">
            Información que recopilamos y recibimos sobre usted
          </h2>

          <p>
            Su privacidad es muy importante para nosotros. En consecuencia, hemos
            desarrollado esta Política para que usted entienda cómo recogemos, usamos,
            comunicamos y revelamos y hacemos uso de la información personal.
          </p>

          <p>
            Antes o en el momento de recopilar la información personal, identificaremos
            los propósitos para los que se está recopilando la información.
          </p>

          <p>
            Recopilaremos y utilizaremos la información personal únicamente con el
            objetivo de cumplir con los propósitos especificados por nosotros y para otros
            propósitos compatibles, a menos que obtengamos el consentimiento del individuo
            en cuestión o según lo requiera la ley.
          </p>

          <p>
            Popsy collects information about installed apps to prevent fraud, ensure user
            security and conduct analysis for the purposes of improving security and
            evaluating potential threats.
          </p>

          <p>
            Sólo conservaremos la información personal durante el tiempo necesario para el
            cumplimiento de esos fines.
          </p>

          <p>
            Recopilaremos información personal por medios legales y justos y, cuando
            proceda, con el conocimiento o el consentimiento del individuo en cuestión.
          </p>

          <p>
            Los datos personales deben ser pertinentes para los fines para los que se van
            a utilizar y, en la medida en que sean necesarios para esos fines, deben ser
            exactos, completos y actualizados.
          </p>

          <p>
            Protegeremos la información personal mediante garantías de seguridad
            razonables contra la pérdida o el robo, así como contra el acceso, la
            divulgación, la copia, el uso o la modificación no autorizados.
          </p>

          <p>
            Pondremos a disposición de los clientes información sobre nuestras políticas y
            prácticas relacionadas con la gestión de la información personal.
          </p>

          <p>
            Nos comprometemos a llevar a cabo nuestro negocio de acuerdo con estos
            principios para asegurar que la confidencialidad de la información personal
            sea protegida y mantenida.
          </p>

          <h2 id="c%C3%B3mousamoslainformaci%C3%B3nrecopilada">
            Cómo usamos la información recopilada
          </h2>

          <p>
            Podemos recopilar información de identificación personal de los Usuarios de
            diversas maneras en relación con las actividades, servicios, características o
            recursos que ponemos a disposición en nuestras Aplicaciones Móviles.
          </p>

          <p>
            Los usuarios pueden visitar nuestra Aplicación Móvil de forma anónima.
            Recopilaremos información de identificación personal de los Usuarios sólo si
            nos la envían voluntariamente. Los usuarios siempre pueden negarse a
            suministrar información de identificación personal, excepto que esto les
            impida participar en ciertas actividades relacionadas con el Sitio.
          </p>

          <p>
            Podemos recopilar información de identificación no personal de los Usuarios
            siempre que interactúen con nuestras Aplicaciones móviles. La información de
            identificación no personal puede incluir el nombre del navegador, el tipo de
            computadora e información técnica sobre los medios de conexión de los Usuarios
            a nuestro Sitio, como el sistema operativo y los proveedores de servicios de
            Internet utilizados y otra información similar.
          </p>

          <p>
            Popsy and Popsy, LLC puede recopilar y utilizar la información personal de los
            Usuarios para los siguientes fines: Personalizar la experiencia del usuario -
            Podemos utilizar la información en conjunto para comprender cómo nuestros
            usuarios, como grupo, utilizan los servicios y recursos proporcionados en
            nuestras aplicaciones móviles.
          </p>

          <h2 id="compartirsuinformaci%C3%B3npersonal">
            Compartir su información personal
          </h2>

          <p>
            No vendemos, comerciamos o alquilamos la información de identificación
            personal de los usuarios a otros. Podemos compartir información demográfica
            agregada genérica no vinculada a ninguna información de identificación
            personal de los visitantes y usuarios con nuestros socios comerciales,
            afiliados de confianza y anunciantes para los fines indicados anteriormente.
          </p>

          <h2 id="cambiosenestapol%C3%ADticadeprivacidad">
            Cambios en esta política de privacidad
          </h2>

          <p>
            Popsy y Popsy, LLC tienen la discreción de actualizar esta política de
            privacidad en cualquier momento. Cuando lo hagamos, revisaremos la fecha de
            actualización en la parte superior de esta página. Recomendamos a los usuarios
            que consulten con frecuencia esta página para conocer los cambios y mantenerse
            informados sobre cómo ayudamos a proteger la información personal que
            recopilamos. Usted reconoce y acepta que es su responsabilidad revisar esta
            política de privacidad periódicamente y estar al tanto de las modificaciones.
          </p>

          <h2 id="suaceptaci%C3%B3ndeestost%C3%A9rminos">
            Su aceptación de estos términos
          </h2>

          <p>
            Al utilizar nuestros servicios, usted indica que acepta esta política y los
            términos y condiciones. Si no está de acuerdo, por favor no utilice nuestros
            servicios. El uso continuado de nuestros Servicios después de la publicación
            de los cambios en esta política se considerará como su aceptación de dichos
            cambios.
          </p>

          <h2 id="contactarconnosotros">Contactar con nosotros</h2>

          <p>
            Si tiene preguntas o inquietudes sobre nuestras prácticas de privacidad o
            desea hacer una solicitud con respecto a Su Información, por favor contáctenos
            en <a href="mailto:contact@popsy.app">contact&#64;popsy.app</a>
          </p>

          <h2 id="delete-my-account">Borrar mi cuenta</h2>

          <p>
            Nos entristece mucho que te vayas, y nos encantaría saber qué podemos hacer
            para mejorar tu experiencia en Popsy, por favor envíanos un correo electrónico
            a
            <a href="mailto:contact@popsy.app?subject=Delete%20my%20account"
              >contact&#64;popsy.app</a
            >
            con tus comentarios, y los leeremos y utilizaremos para mejorar nuestra
            aplicación.
          </p>
          <p>
            Si lo tienes claro, y quieres eliminar tu cuenta, simplemente sigue estos
            pasos.
          </p>

          <h3 id="delete-my-account-android">Android</h3>

          <ul>
            <li>Abre Popsy</li>
            <li>Desliza el panel derecho de la pantalla de inicio</li>
            <li>
              Pulsa el botón con los tres puntos para ver más opciones en la parte
              superior derecha
            </li>
            <li>Pulsa sobre "Abrir preferencias".</li>
            <li>Pulse el botón con los tres puntos en la parte superior derecha.</li>
            <li>Pulse sobre "Eliminar mi cuenta".</li>
            <li>Pulse continuar en el diálogo de confirmación</li>
          </ul>

          <h3 id="delete-my-account-web">Web</h3>

          <ul>
            <li>Vaya a https://www.popsy.app/ y conéctese con su cuenta.</li>
            <li>Vaya a https://www.popsy.app/es/settings/user</li>
            <li>Confirma que quieres eliminar tu cuenta.</li>
          </ul>

          <h3 id="delete-my-account-ios">iOS</h3>

          <ul>
            <li>Abrir Popsy</li>
            <li>Inicie sesión con su cuenta</li>
            <li>Ve a la pantalla de ajustes</li>
            <li>Pulsa sobre 'eliminar cuenta'</li>
          </ul>
        </ng-container>
        <ng-container *ngIf="lang === 'AR'">
          <h1 id="privacypolicy">سياسة الخصوصية</h1>

          <h5 id="lastupdated%3Ajanuary10th2019">آخر تحديث: 10 يناير 2019</h5>

          <p>
            تصف سياسة الخصوصية هذه ممارسات Popsy المقدمة من خلال Popsy, LLC فيما يتعلق
            بمعلومات وبيانات التعريف الشخصية (”المعلومات الشخصية“). تنطبق هذه السياسة على
            مواقعنا الإلكترونية وتطبيقات الهواتف ورسائل البريد الإلكتروني والرسائل النصية
            وحسابات التواصل الاجتماعي ("المنصات"). عند استخدامك للمنصات، فإنك توافق على
            الشروط الواردة في هذه السياسة.
          </p>

          <h2 id="informationwecollectandreceiveaboutyou">
            المعلومات التي نجمعها ونتلقاها حولك
          </h2>

          <p>
            تعد خصوصيتك مهمة جدًا بالنسبة لنا. بناءًا على ذلك، وضعنا هذه السياسة لتعرف كيف
            نجمع المعلومات الشخصية ونستخدمها ونتواصل معها ونكشف عنها ونستفيد منها.
          </p>

          <p>
            سوف نحدد الأغراض التي يتم جمع المعلومات من أجلها قبل أو في وقت جمع البيانات
            الشخصية. سنقوم بجمع واستخدام البيانات الشخصية فقط بهدف تحقيق تلك الأغراض
            المحددة من طرفنا ولأغراض أخرى مطابقة ما لم نحصل على موافقة الفرد المعني أو
            وفقًا لما يقتضيه القانون. سنحتفظ بالمعلومات الشخصية فقط في حال كان هذا الأمر
            ضروريًا لتحقيق تلك الأغراض. سنجمع المعلومات الشخصية بوسائل قانونية وعادلة،
            وعند الاقتضاء، بمعرفة أو موافقة الفرد المعني. يجب أن تكون البيانات الشخصية ذات
            صلة بالأغراض التي سيتم استخدامها من أجلها ويجب أن تكون دقيقة وكاملة وحديثة
            بالقدر اللازم لتلك الأغراض.
          </p>

          <p>
            سنحمي المعلومات الشخصية من خلال ضمانات أمنية منطقية من الضياع أو السرقة أو
            الوصول غير المصرح به أو النشر أو النسخ أو الاستخدام أو التعديل. سنوفر للعملاء
            معلومات حول سياساتنا وممارساتنا المتعلقة بإدارة المعلومات الشخصية. نحن ملتزمون
            بإجراء أعمالنا وفقًا لهذه المبادئ من أجل ضمان حماية سرية المعلومات الشخصية
            والحفاظ عليها.
          </p>

          <p>
            Popsy يجمع معلومات حول التطبيقات المثبتة لمنع الاحتيال، وضمان أمان المستخدم،
            وإجراء تحليلات بهدف تحسين الأمان وتقييم التهديدات المحتملة.
          </p>

          <h2 id="howweusecollectedinformation">كيف نستخدم المعلومات التي يتم جمعها</h2>

          <p>
            قد نقوم بجمع معلومات التعريف الشخصية من المستخدمين بطرق متنوعة فيما يتعلق
            بالنشاطات أو الخدمات أو الميزات أو الموارد التي نوفرها على تطبيقات المحمول
            الخاصة بنا.
          </p>

          <p>
            يمكن للمستخدمين زيارة تطبيق الهاتف المحمول الخاص بنا دون الكشف عن هويتهم.
            سنجمع معلومات التعريف الشخصية من المستخدمين
          </p>

          <p>
            فقط إذا قدموا هذه المعلومات برغبتهم. يمكن للمستخدمين رفض تقديم معلومات التعريف
            الشخصية دومًا، باستثناء أن هذا الأمر قد يمنعهم من المشاركة في أنشطة معينة
            بالموقع.
          </p>

          <p>
            قد نجمع معلومات تعريف غير شخصية عن المستخدمين كلما تفاعلوا مع تطبيقات الهاتف
            المحمول الخاصة بنا. قد تتضمن معلومات التعريف غير الشخصية اسم المتصفح ونوع
            الكمبيوتر ومعلومات فنية حول وسائل اتصال المستخدمين بموقعنا، مثل نظام التشغيل
            وموفري خدمة الإنترنت المستخدَمين ومعلومات أخرى مماثلة.
          </p>

          <p>
            قد تقوم (Popsy) و (Popsy, LLC) بجمع واستخدام المعلومات الشخصية للمستخدمين
            للأغراض التالية: لتخصيص تجربة المستخدم - قد نستخدم المعلومات في الإجمال لفهم
            كيفية استخدام مستخدمينا للخدمات والموارد المتوفرة على تطبيقات الأجهزة المحمولة
            الخاصة بنا.
          </p>

          <h2 id="sharingyourpersonalinformation">مشاركة المعلومات الشخصية الخاصة بك</h2>

          <p>
            نحن لا نبيع أو نتاجر أو نؤجر معلومات التعريف الخاصة بالمستخدمين للآخرين. قد
            نشارك معلومات ديموغرافية مجمعة عامة غير مرتبطة بأي معلومات تعريف شخصية تتعلق
            بالزوار والمستخدمين مع شركائنا والشركات التابعة والمعلنين الموثوق بهم للأغراض
            الموضحة أعلاه.
          </p>

          <h2 id="changestothisprivacypolicy">التغييرات على سياسة الخصوصية هذه</h2>

          <p>
            لدى (Popsy) و (Popsy, LCC) الصلاحية التقديرية لتحديث سياسة الخصوصية هذه في أي
            وقت. سنقوم بمراجعة التاريخ المحدث في أعلى هذه الصفحة عند إجراء أي تغيير. نحن
            نشجع المستخدمين على التحقق من هذه الصفحة بشكل مستمر بحثًا عن أي تغييرات، وذلك
            للبقاء على اطلاع حول كيفية مساعدتنا في حماية المعلومات الشخصية التي نجمعها.
            أنت تقر وتوافق على أنه من مسؤوليتك مراجعة سياسة الخصوصية هذه بشكل دوري
            والاطلاع على التعديلات.
          </p>

          <h2 id="youracceptanceoftheseterms">موافقتك على هذه الشروط</h2>

          <p>
            باستخدامك لخدماتنا، أنت توافق على هذه السياسة والأحكام والشروط. في حال عدم
            موافقتك، يرجى منك عدم استخدام خدماتنا. إن استمرار استخدامك لخدماتنا بعد نشر
            التغييرات على هذه السياسة سيعتبر بمثابة موافقتك على هذه التغييرات.
          </p>

          <h2 id="contactingus">الاتصال بنا</h2>

          <p>
            إذا كانت لديك أي أسئلة أو مخاوف بشأن ممارسات الخصوصية لدينا أو كنت ترغب في
            تقديم طلب بخصوص معلوماتك، فيرجى منك الاتصال بنا عبر
            <a href="mailto:contact@popsy.app">contact&#64;popsy.app</a>
          </p>

          <h2 id="delete-my-account">حذف حسابي</h2>

          <p>
            نحن حزينون للغاية لرؤيتك تغادر ، ونود أن نعرف ما يمكننا القيام به لتحسين
            تجربتك على Popsy ، يرجى مراسلتنا عبر البريد الإلكتروني على
            <a href="mailto:contact@popsy.app?subject=Delete%20my%20account"
              >contact&#64;popsy.app</a
            >
            مع تعليقاتك ، وسوف نقرأها ونستخدمها لإنشاء تطبيقنا أفضل.
          </p>
          <p>
            إذا كنت واضحًا بشأن ذلك ، وتريد حذف حسابك ، فما عليك سوى اتباع هذه الخطوات.
          </p>

          <h3 id="delete-my-account-android">ذكري المظهر</h3>

          <ul>
            <li>افتح Popsy</li>
            <li>حرك اللوحة اليمنى من الشاشة الرئيسية</li>
            <li>
              اضغط على الزر ذي النقاط الثلاث لرؤية المزيد من الخيارات في الجزء الأيمن
              العلوي.
            </li>
            <li>اضغط على "فتح التفضيلات"</li>
            <li>اضغط على الزر ذي النقاط الثلاث في الجزء الأيمن العلوي.</li>
            <li>اضغط على "حذف حسابي"</li>
            <li>اضغط على "متابعة" في مربع حوار التأكيد</li>
          </ul>

          <h3 id="delete-my-account-web">الويب</h3>

          <ul>
            <li>اذهب إلى https://www.popsy.app/ وقم بتسجيل الدخول بحسابك.</li>
            <li>اذهب إلى https://www.popsy.app/es/settings/user</li>
            <li>قم بتأكيد رغبتك في حذف حسابك.</li>
          </ul>

          <h3 id="delete-my-account-ios">iOS</h3>

          <ul>
            <li>افتح Popsy</li>
            <li>تسجيل الدخول بحسابك</li>
            <li>انتقل إلى شاشة الإعدادات</li>
            <li>اضغط على "حذف الحساب"</li>
          </ul>
        </ng-container>
        <ng-container
          *ngIf="lang !== 'PT' && lang !== 'FR' && lang !== 'ES' && lang !== 'AR'">
          <h1 id="privacypolicy">Privacy Policy</h1>

          <h5 id="lastupdated%3Ajanuary10th2019">Last updated: August 28th, 2022</h5>

          <p>
            This Privacy Policy describes Popsy’s practices, represented by Popsy, LLC,
            regarding personally identifiable information and data (“personal
            information”). This policy applies to our websites, mobile applications, email
            and text messages, and social media accounts (the “Platforms”). When you use
            the Platforms, you agree to the terms in this policy. We are committed to
            ensuring the best level of protection for your data, in accordance with the EU
            Regulation 2016/679 of the European Parliament and the Council of April 27,
            2016 regarding the protection of natural persons in regard to the processing
            of Personal Data, the General Regulation on Data Protection (GDPR) along with
            the California Consumer Privacy Act (CCPA) of 2018.
          </p>

          <h2 id="informationwecollectandreceiveaboutyou">
            Information we collect and receive about you
          </h2>

          <p>
            Your privacy is very important to us. Accordingly, we have developed this
            Policy in order for you to understand how we collect, use, communicate and
            disclose and make use of personal information.
          </p>

          <p>
            Before or at the time of collecting personal information, we will identify the
            purposes for which information is being collected.
          </p>

          <p>
            We will collect and use of personal information solely with the objective of
            fulfilling those purposes specified by us and for other compatible purposes,
            unless we obtain the consent of the individual concerned or as required by
            law.
          </p>

          <p>
            Popsy collects information about installed apps to prevent fraud, ensure user
            security and conduct analysis for the purposes of improving security and
            evaluating potential threats.
          </p>

          <p>
            We will only retain personal information as long as necessary for the
            fulfillment of those purposes. We will collect personal information by lawful
            and fair means and, where appropriate, with the knowledge or consent of the
            individual concerned. Personal data should be relevant to the purposes for
            which it is to be used, and, to the extent necessary for those purposes,
            should be accurate, complete, and up-to-date.
          </p>

          <p>
            We will protect personal information by reasonable security safeguards against
            loss or theft, as well as unauthorized access, disclosure, copying, use or
            modification. We will make readily available to customers information about
            our policies and practices relating to the management of personal information.
          </p>

          <p>
            We are committed to conducting our business in accordance with these
            principles in order to ensure that the confidentiality of personal information
            is protected and maintained.
          </p>

          <p>Data collected on Popsy are divided into 2 major categories:</p>
          <ul>
            <li>
              The data received directly from you when you set up your account or during
              interactions with our customer service department, or changes to your
              profile
            </li>
            <li>
              The data that we automatically collect through your activities on the site
            </li>
          </ul>

          <h3 id="datareceivedfromtheuser">Data received from the user</h3>

          <p>
            The mandatory or voluntary nature of the data is reported to you at the time
            it is collected: title, last name, first name. Some data are automatically
            collected through your activities on the site: navigation data, history of
            shipping address, invoicing address, email address, password, date of birth
            and age of majority (older than 18), credit/debit card information number,
            telephone number, company.
          </p>

          <p>
            Popsy restricts access by persons of less than 18 years of age, who cannot
            make a purchase without parental authorization. In addition, data on contacts
            with customer service are also collected. Orders, preferences and interests,
            products viewed, products added to the cart, delivery incidents, claims.
          </p>

          <p>
            We also perform analytics measurements: for example, we measure the number of
            pages viewed, the number of visits to the site, and the activity of visitors
            on the site and their return rate. Finally, we collect data using cookies.
          </p>

          <h3 id="bankingdata">Banking data</h3>

          <p>
            For payment requirements, banking information is collected and retained by our
            service provider for Stripe certified PCI-DSS payment. This standard is an
            international standard, the purpose of which is to ensure the confidentiality
            and integrity of card holder data, and to protect credit card and transaction
            data.
          </p>

          <p>
            Stripe encrypts the data and only retains it for 3 years for technical
            purposes (for example: for a recurring payment requested by the user at the
            time of purchase, such as insurance, or the reimbursement of a purchase, or in
            case of fraudulent behavior). The encrypted payment data are held in secure
            data centers in the USA.
          </p>

          <h2 id="howweusecollectedinformation">How we use collected information</h2>

          <p>
            We may collect personal identification information from Users in a variety of
            ways in connection with activities, services, features or resources we make
            available on our Mobile Applications.
          </p>

          <p>
            Users may visit our Mobile Application anonymously. We will collect personal
            identification information from Users only if they voluntarily submit such
            information to us. Users can always refuse to supply personally identification
            information, except that it may prevent them from engaging in certain Site
            related activities.
          </p>

          <p>We collect the information that you have given us when:</p>
          <ul>
            <li>you set up your account</li>
            <li>you make an order on our sites</li>
            <li>you navigate on our sites and view our products</li>
            <li>you contact our Customer Service</li>
            <li>you post a review</li>
          </ul>

          <p>
            Users may visit our Mobile Application anonymously. We will collect personal
            identification information from Users only if they voluntarily submit such
            information to us. Users can always refuse to supply personally identification
            information.
          </p>

          <p>
            We may collect non-personal identification information about Users whenever
            they interact with our Mobile Applications. Non-personal identification
            information may include the browser name, the type of computer and technical
            information about Users means of connection to our Site, such as the operating
            system and the Internet service providers utilized and other similar
            information.
          </p>

          <p>
            Popsy and Popsy, LLC may collect and use Users personal information for the
            following purposes:
          </p>

          <ul>
            <li>
              To personalize user experience – We may use information in the aggregate to
              understand how our Users as a group use the services and resources provided
              on our Mobile Applications
            </li>
            <li>
              To provide, maintain and improve our services, develop new features and send
              product updates and administrative messages;
            </li>
            <li>
              To perform internal operations, including troubleshooting, data analysis,
              testing and research; and
            </li>
            <li>
              To keep you informed of news and offers that you can take advantage of: you
              may receive offers by electronic communication (email, sms, etc.). We
              measure the opening rates of our communications to better adapt to your
              needs. If you do not want to receive Popsy offers and information, you can
              opt out of mailings by notifying it when you set up your account, or at any
              time by using the unsubscribe link at the bottom of the emails. Depending on
              the choices made during the creation or viewing of your account, you are
              likely to receive offers from Popsy.
            </li>
            <li>
              To manage your order: the information and data concerning you are necessary
              to the management of your order, that is, each purchase of goods and/or
              services made by a customer on our Sites under the conditions laid out in
              the Terms of Service supplemented, when necessary, by specific conditions.
              This information may also be retained for purposes of evidence regarding
              adherence to legal and regulatory requirements (payments, guarantees,
              disputes, etc.)
            </li>
          </ul>

          <h3 id="durationofdataretention">Duration of data retention</h3>

          <p>
            Your Personal Data regarding your account, as well as those regarding your
            navigation and/or your behavior on the site are retained for 3 years from your
            last activity on the site or electronic communication support with Popsy or
            for 6 years from your last order unless otherwise provided by the applicable
            laws and regulations. At the end of this time, your account is considered
            “inactive” and will automatically be deactivated. It is up to you to create a
            new account for any order.
          </p>

          <h3 id="sharingyourpersonalinformation">Sharing your personal information</h3>

          <p>
            We do not sell, trade, or rent Users personal identification information to
            others. We may share generic aggregated demographic information not linked to
            any personal identification information regarding visitors and users with our
            business partners, trusted affiliates and advertisers for the purposes
            outlined above.
          </p>

          <p>
            We do not knowingly collect or store personally identifiable information from
            anyone under the age of 13 unless or except as permitted by law. BY INSTALLING
            OR USING OUR APP, YOU REPRESENT AND WARRANT TO US THAT YOU ARE 13 YEARS OF AGE
            OR OLDER. If we are made aware that we have received personally identifiable
            information from someone under 13, we will use reasonable efforts to remove
            that information from our records.
          </p>

          <h2 id="changestothisprivacypolicy">Email Opt-Out</h2>

          <p>
            You can at any time tell us not to send you marketing communications by email
            by clicking on the unsubscribe link within the marketing emails you receive
            from us or by contacting us as indicated below. You also may opt out of
            receiving marketing emails from us by emailing us at
            <a href="mailto:support@popsy.app">support&#64;popsy.app</a>.
          </p>

          <h2 id="changestothisprivacypolicy">Text Marketing & Notifications</h2>

          <p>
            By subscribing to text marketing notifications you agree to receive recurring
            automated marketing messages and shopping cart reminder messages at the phone
            number provided.
          </p>

          <p>
            <strong>
              We determine cart abandoned by using a cookie and check whether the existing
              user has already opted in for text marketing.
            </strong>
          </p>

          <p>
            <strong>
              Consent is not a condition of purchases. Reply STOP to unsubscribe. HELP for
              help. Msg & Data rates may apply.
            </strong>
          </p>

          <p>
            If you do not wish to be part of our service you can unsubscribe at any time
            by testing STOP, CANCEL, QUIT, END, or UNSUBSCRIBE to any mobile message
            received from us. You may get another text message confirming your
            unsubscribing from our service. You also agree that by sending an email,
            calling in, or sending any other means of opt out unsubscribe request or using
            words different than the ones presented above will not be reasonable means to
            unsubscribe you.
          </p>

          <p>
            When you opt in for our service you may expect to get occasional texts
            concerning latest Text Alerts, Surveys, Welcome messages, Customer win-backs,
            Text Campaigns, Giveaways, Flash Sales, Upsells.
          </p>

          <p>
            If your device does not support MMS we will deliver a SMS instead and strip
            the image. The opt out will also be delivered as a standard text message
            (SMS).
          </p>

          <h2 id="changestothisprivacypolicy">
            Carriers are not responsible or liable for undelivered or delayed messages.
          </h2>

          <p>
            California Civil Code Section 1798.83 permits Users of the Program that are
            California residents to request certain information regarding our disclosure
            of the information you provide through the Program to third parties for their
            direct marketing purposes. To make such a request, please contact us at the
            following address:
          </p>

          <p>Popsy atividades de internet LTDA</p>

          <p>Av. Paulista, 1374, 11º Andar Bela Vista - São Paulo, SP 01310-100</p>

          <p>
            <a href="mailto:support@popsy.app">support&#64;popsy.app</a>
          </p>

          <p>
            This Privacy Policy is strictly limited to the Program and has no effect on
            any other privacy policy(ies) that may govern the relationship between you and
            Us in other contexts.
          </p>

          <h2 id="changestothisprivacypolicy">Geo-Location Information</h2>

          <p>
            When you use one of our mobile applications, we may ask you for your
            geo-location. You may choose not to share your geo-location details by
            adjusting your mobile device’s location services settings. To decline from
            sharing your geo-location details, follow the instructions on your mobile
            device on changing the relevant settings; otherwise, please contact your
            service provider or device manufacturer.
          </p>

          <h2 id="changestothisprivacypolicy">Withdrawing Consent</h2>

          <p>
            You may also withdraw any consent you previously provided to us at any time
            with effect for the future by contacting us as indicated below. This will not
            affect the lawfulness of our use of your information based on your consent
            before its withdrawal.
          </p>

          <h2 id="changestothisprivacypolicy">Changes to this privacy policy</h2>

          <p>
            Popsy and Popsy, LLC have the discretion to update this privacy policy at any
            time. When we do, we will revise the updated date at the top of this page. We
            encourage Users to frequently check this page for any changes to stay informed
            about how we are helping to protect the personal information we collect. You
            acknowledge and agree that it is your responsibility to review this privacy
            policy periodically and become aware of modifications.
          </p>

          <h2 id="youracceptanceoftheseterms">Your acceptance of these terms</h2>

          <p>
            By using our Services, you signify your acceptance of this policy and terms
            and conditions. If you do not agree please do not use our Services. Your
            continued use of our Services following the posting of changes to this policy
            will be deemed your acceptance of those changes.
          </p>

          <p>
            To opt out of our use of the personal information that we collect about you
            for advertising purposes, please contact us at
            <a href="mailto:support@popsy.app">support&#64;popsy.app</a> with a request
            that we not use your personal information for advertising purposes, and we
            will honor that request.
          </p>

          <h2 id="contactingus">Contacting us</h2>

          <p>
            If you have questions or concerns about our privacy practices or wish to make
            a request regarding Your Information, please contact us at
            <a href="mailto:contact@popsy.app">contact&#64;popsy.app</a> or at the
            following address: Popsy atividades de internet LTDA - Av. Paulista, 1374, 11º
            Andar Bela Vista - São Paulo, SP 01310-100
          </p>

          <h2 id="delete-my-account">Deleting my account</h2>

          <p>
            If you want us to delete your Account, you can send us an email to
            <a href="mailto:contact@popsy.app?subject=Delete%20my%20account"
              >contact&#64;popsy.app</a
            >
            with subject: Delete My Account. Popsy will use reasonable efforts to delete
            such information, however please note that information may not be deleted
            immediately from our systems.
          </p>

          <p>If you want to delete your account, simply follow these steps.</p>

          <h3 id="delete-my-account-android">Android</h3>

          <ul>
            <li>Open Popsy</li>
            <li>Slide the right panel from the Home screen</li>
            <li>
              Press the button with the three dots to see more options in the upper right
              part.
            </li>
            <li>Tap on 'Open preferences'</li>
            <li>Press the button with the three dots in the upper right part.</li>
            <li>Tap on 'Delete my account'</li>
            <li>Press continue in the confirmation dialog</li>
          </ul>

          <h3 id="delete-my-account-web">Web</h3>

          <ul>
            <li>Go to https://www.popsy.app/ and log in with your account.</li>
            <li>Go to https://www.popsy.app/settings/user</li>
            <li>Confirm that you want to delete your account.</li>
          </ul>

          <h3 id="delete-my-account-ios">iOS</h3>

          <ul>
            <li>Open Popsy</li>
            <li>Login with your account</li>
            <li>Go to the settings screen</li>
            <li>Tap on 'delete account'</li>
          </ul>
        </ng-container>
      </article>
      <span
        class="fixed-space-64"
        aria-hidden="true"
        *ngIf="(lessThan$ | async)?.mobileL !== true"></span>
      <ng-container *ngIf="!(inFullScreenMode$ | async)">
        <app-footer
          class="footer"
          [class.phone]="(lessThan$ | async)?.mobileL"></app-footer>
      </ng-container>
    </div>
  </div>
</main>
